import React, {Component} from "react";
import "../selectable.css";
import "./IconSelection.css";
import portraits, {unlockedPortraits, lockedPortraits, defaultPortrait} from "../assets";
import {portraitsAltText} from "../assets";

import {
    COMMAND_SELECT_ICON,
    PARAM_ICON
} from "../GlobalDefinitions";
import PropTypes from "prop-types";
import ButtonPrompt from "./ButtonPrompt";

class IconSelection extends Component {

    constructor(props) {
        super(props);

        this.onConfirmButtonClick = this.onConfirmButtonClick.bind(this);
        this.getIconButtonHML = this.getIconButtonHML.bind(this);
        this.isIconInUse = this.isIconInUse.bind(this);
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutID);
    }

    isIconInUse(iconID) {
        let playerOrder = this.props.players;
        for (let i = 0; i < playerOrder.length; i++) {
            let player = playerOrder[i];
            if (this.props.playerToIcon[player] === iconID) {
                return true;
            }
        }
        return false;
    }

    onClickIcon(iconID) {
        if (!this.isIconInUse(iconID)) {
            let data = {};
            data[PARAM_ICON] = iconID;
            this.props.sendWSCommand(COMMAND_SELECT_ICON, data);
        }
    }

    onConfirmButtonClick() {
        if (this.props.playerToIcon[this.props.user] !== defaultPortrait) {
            this.props.onConfirm();
        }
    }

    getIconButtonHML(portraitNames) {
        let iconHTML = [];
        let currPortrait = this.props.playerToIcon[this.props.user];

        portraitNames.forEach(portraitID => {
            if (portraits.hasOwnProperty(portraitID)) {
                let isIconAvailable = !this.isIconInUse(portraitID) || portraitID === currPortrait;
                let isSelected = currPortrait === portraitID;
                iconHTML.push(
                    <img key={portraitID}
                         className={"icon-img"
                                        + (isSelected ? " selected" : "")
                                        + (!isIconAvailable ? " disabled" : "")}
                         alt={portraitsAltText[portraitID]}
                         src={portraits[portraitID]}
                         draggable={false}
                         onClick={() => this.onClickIcon(portraitID)}
                    />
                );
            }
        });

        return (
            <div id={"icon-container"}>
                {iconHTML}
            </div>
        );
    }

    render() {
        let allPortraits = unlockedPortraits.concat(lockedPortraits);

        return (
            <ButtonPrompt
                label={"PLAYER LOOK"}
                renderHeader={() => {
                    return (
                        <>
                            <p>Choose a look, then press confirm.</p>
                            {this.getIconButtonHML(allPortraits)}
                        </>
                    );
                }}
                buttonDisabled={(this.props.playerToIcon[this.props.user] === defaultPortrait)}
                buttonOnClick={this.onConfirmButtonClick}
            >
            </ButtonPrompt>
        );
    }

}

IconSelection.defaultProps = {
    onClickTweet: () => {},
    onClickFBShare: () => {},
};

IconSelection.propTypes = {
    playerToIcon: PropTypes.object.isRequired,
    players: PropTypes.array.isRequired,
    sendWSCommand: PropTypes.func.isRequired,
    user: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onClickTweet: PropTypes.func,
    onClickFBShare: PropTypes.func,
};

export default IconSelection;
